import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { PricingProvider } from './contexts/PricingContext';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PainPointsSection } from './components/PainPointsSection';
import { Footer } from './components/Footer';
// Lazy load below-fold components for performance
const ImageCarousel = lazy(() => import('./components/ImageCarousel').then(module => ({
  default: module.ImageCarousel
})));
const AchievementsSection = lazy(() => import('./components/AchievementsSection').then(module => ({
  default: module.AchievementsSection
})));
const VisualContentGrid = lazy(() => import('./components/VisualContentGrid').then(module => ({
  default: module.VisualContentGrid
})));
const ProductPresentation = lazy(() => import('./components/ProductPresentation').then(module => ({
  default: module.ProductPresentation
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(module => ({
  default: module.BonusSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(module => ({
  default: module.TestimonialsSection
})));
const OrderSummary = lazy(() => import('./components/OrderSummary').then(module => ({
  default: module.OrderSummary
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(module => ({
  default: module.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(module => ({
  default: module.FAQSection
})));
const FeaturesSection = lazy(() => import('./components/FeaturesSection').then(module => ({
  default: module.FeaturesSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(module => ({
  default: module.FinalCTA
})));
// Loading fallback component
const SectionLoader = () => <div className="py-16 bg-parchment-100 flex justify-center" data-id="element-0">
    <div className="w-8 h-8 border-4 border-gold-400 border-t-transparent rounded-full animate-spin" data-id="element-1"></div>
  </div>;
export function App() {
  // UTMify Pixel Integration
  useEffect(() => {
    // Set pixel ID
    ;
    (window as any).pixelId = '69a2eb67303d487dd426e1c6';
    // Load pixel script
    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('defer', '');
    script.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
    document.head.appendChild(script);
    // AddToCart event listener for all CTA links
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href*="cart"]');
      if (anchor) {
        try {
          if (typeof (window as any).Utmify !== 'undefined') {
            ;
            (window as any).Utmify.trackEvent('AddToCart');
          }
          // Fallback: dispatch custom event for pixel
          window.dispatchEvent(new CustomEvent('utmify:addtocart'));
        } catch (err) {
          // Silent fail
        }
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  return <PricingProvider data-id="element-2">
      <div className="min-h-screen flex flex-col font-body bg-parchment-100 text-gray-900 overflow-x-hidden" data-id="element-3">
        <StickyAlertBar data-id="element-4" />

        <main className="flex-grow pt-2 md:pt-8" data-id="element-5">
          <HeroSection data-id="element-6" />

          <PainPointsSection data-id="element-7" />

          <Suspense fallback={<SectionLoader data-id="element-9" />} data-id="element-8">
            <div className="content-section" data-id="element-10">
              <ImageCarousel data-id="element-11" />
            </div>
            <div className="content-section" data-id="element-12">
              <AchievementsSection data-id="element-13" />
            </div>
            <div className="content-section" data-id="element-14">
              <VisualContentGrid data-id="element-15" />
            </div>
            <div className="content-section" data-id="element-16">
              <ProductPresentation data-id="element-17" />
            </div>

            <div className="max-w-xl mx-auto px-4 content-section" data-id="element-18">
              <CountdownTimer data-id="element-19" />
            </div>

            <div className="content-section" data-id="element-20">
              <BonusSection data-id="element-21" />
            </div>
            <div className="content-section" data-id="element-22">
              <TestimonialsSection data-id="element-23" />
            </div>
            <div className="content-section" data-id="element-24">
              <OrderSummary data-id="element-25" />
            </div>
            <div className="content-section" data-id="element-26">
              <GuaranteeSection data-id="element-27" />
            </div>
            <div className="content-section" data-id="element-28">
              <FAQSection data-id="element-29" />
            </div>
            <div className="content-section" data-id="element-30">
              <FeaturesSection data-id="element-31" />
            </div>
            <div className="content-section" data-id="element-32">
              <FinalCTA data-id="element-33" />
            </div>
          </Suspense>
        </main>

        <Footer data-id="element-34" />
      </div>
    </PricingProvider>;
}